import { environment } from 'src/environments/environment';

export const settings = {
	returnUrlParamName: "return_url",
	endpoints: {
		authRoot: environment.authRoot,
		loginByGoogle: environment.authRoot + "/auth/external/Google",
		loginByFacebook: environment.authRoot + "/auth/external/Facebook",
		logout: environment.authRoot + "/auth/logout",
		gameApp: environment.gameApp
	}
}